import type { IDashboardAdminRepository } from '@yawi/domain';
import type {
    ChartData,
    DashboardMetrics,
    TenantSummary,
} from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

export class ApiDashboardAdminRepository implements IDashboardAdminRepository {
  private readonly basePath = 'v1/admin/dashboard';

  async getMetrics(): Promise<DashboardMetrics> {
    const client = getApiClient();
    const response = await client.get<DashboardMetrics>(`${this.basePath}/metrics`);
    return response;
  }

  async getRevenueChart(months: number = 12): Promise<ChartData> {
    const client = getApiClient();
    const response = await client.get<ChartData>(`${this.basePath}/charts/revenue?months=${months}`);
    return response;
  }

  async getTenantGrowthChart(months: number = 12): Promise<ChartData> {
    const client = getApiClient();
    const response = await client.get<ChartData>(`${this.basePath}/charts/tenant-growth?months=${months}`);
    return response;
  }

  async getApiUsageChart(months: number = 12): Promise<ChartData> {
    const client = getApiClient();
    const response = await client.get<ChartData>(`${this.basePath}/charts/api-usage?months=${months}`);
    return response;
  }

  async getRecentTenants(limit: number = 5): Promise<TenantSummary[]> {
    const client = getApiClient();
    const response = await client.get<{ data: TenantSummary[] }>(
      `${this.basePath}/recent-tenants?limit=${limit}`
    );
    return response.data;
  }

  async getTopTenantsByRevenue(limit: number = 5): Promise<TenantSummary[]> {
    const client = getApiClient();
    const response = await client.get<{ data: TenantSummary[] }>(
      `${this.basePath}/top-tenants?limit=${limit}`
    );
    return response.data;
  }
}
